// extracted by mini-css-extract-plugin
export default {"wrapper":"Order_wrapper__TTgzx","text-title":"Order_text-title__yeV19","text-title-loading":"Order_text-title-loading__mU5ag"};